import { render, staticRenderFns } from "./erweima.vue?vue&type=template&id=2f2c4afd&scoped=true&"
import script from "./erweima.vue?vue&type=script&lang=js&"
export * from "./erweima.vue?vue&type=script&lang=js&"
import style0 from "./erweima.vue?vue&type=style&index=0&id=2f2c4afd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c4afd",
  null
  
)

export default component.exports